/**
 * 执行C++代码
 */

import store from "../store";
import i18n from '../utils/i18n';
import decomment from 'decomment';

const CppCodeLenthLimit = 1000;
const CppCodeLineLimit = 80;

const LoopSymbols = ["for", "while"];
const ICodeRoles = ["Dev", "Spaceship", "Flyer", "Ship"];
const ICodeActions = ["step", "turnLeft", "turnRight"];
const ICodeUnsupportWords = ["class", "define", "cin", "cout", "asm", "auto", "catch", "delete", "enum", "explicit", "export", "extern", 
    "friend", "inline", "mutable", "namespace", "include", "new", "operator", "protected", "public", "register", "sizeof", "static", "struct",
    "template", "this", "throw", "try", "typedef", "union", "using", "virtual", "function", "editor", "debugger", "window", "document", "eval",
    "extends", "finally", "import", "instanceof", "null", "super", "typeof", "undefined", "with", "yield", "async", "await"
];
const CppVarWords = ["float", "int", "void", "double"];
const EasyErrorSymbols = ["，", "。", "：", "；", "{", "}", "？", "#"];


export const cppActionArray =  [
    { id: 20, describe: 'step', img: process.env.IMG_BASE_URL + 'mars_step.png', code: '.step();', tips: 'step' },
    { id: 21, describe: 'turnLeft', img: process.env.IMG_BASE_URL + 'mars_turnLeft.png', code: '.turnLeft();', tips: 'turnLeft' },
    { id: 22, describe: 'turnRight', img: process.env.IMG_BASE_URL + 'mars_turnRight.png', code: '.turnRight();', tips: 'turnRight' },
    { id: 25, describe: 'for', img: process.env.IMG_BASE_URL + 'mars_for.png', code: 'for(int i=0; i<4; i++) {\n', tips: 'for' },
    { id: 30, describe: 'while', img: process.env.IMG_BASE_URL + 'mars_while.png', code: 'while (true) {\n', tips: 'while' },
    { id: 33, describe: 'function', img: process.env.IMG_BASE_URL + 'mars_function.png', code: 'int func()', tips: 'function' },
    { id: 35, describe: 'if', img: process.env.IMG_BASE_URL + 'mars_if.png', code: 'if (true) {\n', tips: 'if' },
    { id: 36, describe: 'if_else', img: process.env.IMG_BASE_URL + 'mars_ifelse.png', code: ' else {\n', tips: 'if_else' },
    { id: 38, describe: 'wait', img: process.env.IMG_BASE_URL + 'mars_wait.png', code: 'wait();', tips: 'wait' },
    { id: 43, describe: 'power', img: process.env.IMG_BASE_URL + 'mars_health.png', code: '.energy;', tips: 'energy' },
    { id: 45, describe: 'broken', img: process.env.IMG_BASE_URL + 'mars_broken.png', code: '.broken();', tips: 'broken' },
    { id: 48, describe: 'return', img: process.env.IMG_BASE_URL + 'mars_return.png', code: 'return;', tips: 'return' },
    { id: 53, describe: 'disappear', img: process.env.IMG_BASE_URL + 'mars_disapper.png', code: '.disappear();', tips: 'disappear' }
];

function showFailInfo(title, body){
    store.state.failDialogChina = true;
    store.state.failTitle = title;
    store.state.failText = body;
}

function countWord(line, target) {
    const words = line.toLowerCase().split(/[\W_]+/);
    return words.filter(word => word === target.toLowerCase()).length;
}

// 计算一行代码中的loop指令数
function countActions(line, actions) {
    let cnt = 0;
    
    actions.forEach(action => {
        cnt += countWord(line, action);
    })

    return cnt;
}

function findActions(line, actions) {
    const words = line.toLowerCase().split(/[\W_]+/);
    for(let i=0; i<actions.length; i++) {
        let ret = words.filter(word => word === actions[i]);
        if(ret.length > 0) {
            return actions[i];
        }
    }
}

// 计算一行代码中的ICode指令数
function countICodeActions(line, actions) {
    let cnt = 0;
    
    actions.forEach(action => {
        cnt += countWord(line, action);
    })

    return cnt;
}

// 判断一行代码是函数定义
function isFunction(line) {
    const cppSimpleFuncRegex = /^\s*(int|void|bool)\s+[a-zA-Z_][a-zA-Z0-9_]*\s*\(.*\)\s*\{\s*$/;
    return cppSimpleFuncRegex.test(line);
}


function checkOneLine(lineCode) {
    lineCode = lineCode.trim('\n');


    if(lineCode.includes("'") || lineCode.includes('"')){
        return i18n.t("ICode does not yet support the use of strings.");
    }

    // 限制一行最多80个字符
    if(lineCode.length > CppCodeLineLimit) {
        return i18n.t("Each line of code should be less than 80 characters.");
    }

    // 限制一行使用少于2个动作
    let icodeActionCnt = countICodeActions(lineCode, ICodeActions);
    if(icodeActionCnt >= 2) {
        return i18n.t("ICode restricts the use of multiple actions in the same line of code; {code}", {code: lineCode});
    }

    let loopsActionsCnt = countActions(lineCode, LoopSymbols);
    // 限制一行同时使用多个 for, while 循环动作
    if(loopsActionsCnt >=2) {
        return i18n.t("ICode restricts the use of multiple loops in the same line of code; {code}", {code: lineCode});
    }  

    // 限制一行同时使用多个 for, while 循环动作
    if(loopsActionsCnt >= 1 && icodeActionCnt >= 1) {
        return i18n.t("ICode restricts the use of loops and actions in the same line of code; {code}", {code: lineCode});
    }

    // 必须以分号结尾
    if(icodeActionCnt >= 1) {
        if(!lineCode.includes(";")) {
            return i18n.t("Statements must end with a semicolon");
        }
        if(lineCode.includes("}") || lineCode.includes("{")) {
            return i18n.t("Please put the curly brackets on a separate line");
        }
    }

    EasyErrorSymbols.forEach(symbol => {
        if(lineCode.includes(symbol)) {
            return i18n.t("Symbol error, did you enter a non-standard symbol? {symbol}", {symbol: symbol});
        }
    })

    let unsupportWord = findActions(lineCode, ICodeUnsupportWords);
    if(unsupportWord) {
        return i18n.t("ICode restricts the use of {word} in the challenge.", {word: unsupportWord});
    }

    // 限制 let a = Dev; let a = Dev.step;
    if(lineCode.match(/=.*(Dev|Spaceship|Ship|Flyer).*(step|turnLeft|turnRight)/)){
        return i18n.t("Can not reassign actions.");
    }

    return null;
}


function hasCppArray(cppCode) {
    return cppCode.match(/(const\s+)?(\w+(?:::\w+)?)\s+(\w+)\s*\[\s*\]\s*=\s*\{([^}]*)\}\s*;/)
        || cppCode.match(/(const\s+)?(\w+(?:::\w+)?)\s+(\w+)\s*\[\s*(\w+)\s*\]\s*;/);
}

function cppToJsArrayConverter(cppCode) {
    // 处理简单数组
    let jsCode = cppCode.replace(/(const\s+)?(\w+(?:::\w+)?)\s+(\w+)\s*\[\s*\]\s*=\s*\{([^}]*)\}\s*;/g, 
      'const $3 = [$4];');
    
    // 处理带大小的数组
    jsCode = jsCode.replace(/(const\s+)?(\w+(?:::\w+)?)\s+(\w+)\s*\[\s*(\w+)\s*\]\s*;/g, 
      'let $3 = new Array($4);');
    
    // 处理vector
    jsCode = jsCode.replace(/std::vector\s*<\s*([\w:]+)\s*>\s+(\w+)\s*(?:=\s*\{([^}]*)\})?\s*;/g,
      (match, type, name, values) => values ? `let ${name} = [${values}];` : `let ${name} = [];`);
    
    // 处理字符串数组
    jsCode = jsCode.replace(/(const\s+)?(char\s*\*\s*|std::string\s+)(\w+)\s*\[\s*\]\s*=\s*\{([^}]*)\}\s*;/g,
      'const $3 = [$4];');
    
    return jsCode;
}

/**
 * 运行AceEditor中的代码
 * @param {AceEditor} editor 
 * @returns 
 */
export function runCppCode(editor) {
    
    console.log("Run C++ code");

    // 格式化C++代码
    try {
        editor.beautify.beautify(editor.session);
    } catch (error) {
        console.log(error);
        showFailInfo(i18n.t("Error"), i18n.t(error.stack));
        return;
    }

    
    let playerCode = editor.getValue() || "";

    if(playerCode.length > CppCodeLenthLimit) {
        showFailInfo(i18n.t("Error"), i18n.t("Your code is too long. The limit size is {size} character.", {size: CppCodeLenthLimit}));
        return;
    }

    // console.log(playerCode);
    // 行单独检测
    let decommentCode = "";
    try {
        decommentCode = decomment(playerCode);
    } catch (error) {
        console.log(error);
        showFailInfo(i18n.t("Error"), i18n.t(error.description));
        return;
    }

    // 不支持数组定义
    if(hasCppArray(decommentCode)) {
        showFailInfo(i18n.t("Error"), i18n.t("Defining arrays is not supported in ICode"));
        return;
    }

    let dlines = decommentCode.split("\n");
    for(let i=0; i<dlines.length; i++) {

        let line = dlines[i];
        // 限制一行最多80个字符
        let errorInfo = checkOneLine(line);
        if(errorInfo) {
            showFailInfo(i18n.t("Error"), errorInfo);
            return;
        }
    }

    // 加入运行提示
    let lines = playerCode.split("\n");

    let debugLines = [
        "let pow = Math.pow;",
        "let abs = Math.abs;",
        "let max = Math.max;",
        "let min = Math.min;",
        "let sqrt = Math.sqrt;",
        "let True = true;",
        "let False = false;",
    ];

    for(let i=0; i<lines.length; i++) {
        let line = lines[i];
        if(isFunction(line)) {
            line = line.replace(/void /g, " ");
            line = line.replace(/int /g, " ");
            line = "function " + line;
            lines[i] = line;
        }

        // only roles actions matches 
        if(line.trim().startsWith("Dev") || 
            line.trim().startsWith("Spaceship") ||
            line.trim().startsWith("Flyer") ||
            line.trim().startsWith("wait") 
        ){
            debugLines.push(`window._running_code_line_number = ${i+1}`)
        };
        debugLines.push(lines[i]);
    }

    
    let debugCode = debugLines.join("\n");

    // 替换 C++ 为 JavaScript 代码
    debugCode = debugCode.replace(/int /g, "let ");
    debugCode = debugCode.replace(/bool /g, "let ");
    debugCode = debugCode.replace(/char /g, "let ");
    debugCode = debugCode.replace(/auto /g, "let ");

    debugCode = debugCode.replace(/Item/g, "Energy");
    debugCode = debugCode.replace(/void/g, "function");

    // 数组
    /**
     * int a[10];
     * int a[10] = {1, 2, 3, 4, 6};
     */
    const ArrayRegex = /let \s\[\d+\]/;

    // 开始运行前的清理工作
    window._code_is_running = true;
    window.bridge.clearCurrentSteps();
    window._err_line_num_ace = null;
    window._line_num_dict = {};

    try {
        eval(debugCode);
      } catch (error) {
        console.log("eval error");
        console.log(error);
        console.log(String(error));

        // if(e.name == "ReferenceError" && e.message.match(/is not defined/)){
        //     alertInfo = "引用错误：" + e.message.replace("is not defined", "未定义的变量");
        // }
        if(error.name == "SyntaxError"){
            showFailInfo(i18n.t("Error"), i18n.t(String(error) || "Syntax Error"));
            window._code_is_running = false;
            return;
        } else {
            showFailInfo(
                i18n.t("Error"),  
                i18n.t(error.description || error.messeage || String(error) || error.name)
            );
            window._code_is_running = false;
            return;
        }
        
      }
      
      window.bridge.onRunCodeButtonClick(); // 保存代码，弹出窗口
      console.log("Run C++ code end");
}


export function initCppCheck(editor) {
    // 基础正则检查示例
    const basicChecks = [
        { pattern: /=.*{step|turnLeft|turnRight}/, message: 'Lack of for loop conditions' },
    ];

    function runCustomChecks(){
        const playerCode = editor.getValue();
        const originLines = playerCode.split("\n");
        const annotations = [];

        // 行单独检测
        let decommentCode = undefined;
        try {
            decommentCode = decomment(playerCode);
        } catch (error) {
            console.log(error);
            annotations.push({
                row: error.lineNumber-1,
                column: error.column,
                text: i18n.t(error.description),
                type: 'error'
            });
        }

        let dlines = decommentCode ? decommentCode.split("\n") : [];
        for(let i=0; i<dlines.length; i++) {

            let line = dlines[i];

            let errorInfo = checkOneLine(line);
            if(errorInfo){
                let row = originLines.indexOf(line);
                annotations.push({
                    row: row,
                    column: 0,
                    text: errorInfo,
                    type: 'error'
                });
            }
        }

        editor.session.setAnnotations(annotations); 
    };

    let checkTimeout;
    editor.session.on('change', () => {
        clearTimeout(checkTimeout);
        checkTimeout = setTimeout(runCustomChecks, 500);
    });
}

export function initCppEnvironment() {
    store.state.allArr = cppActionArray;
};




// WEBPACK FOOTER //
// ./src/libs/cpp.js